import ArrondissementPage from "../ArrondissementPage";
import { arrondissementsData } from "@/mocks/arrondissements";

export default function ParisArrSudPage() {
  const data = arrondissementsData.find((a) => a.slug === "sud")!;
  return <ArrondissementPage data={data} />;
}
